import { INSURED_TARGETS, InsuredTarget } from '../constants';

// Only the exact value `family` pre-selects the family option.
export const parseInsuredTarget = (value: unknown): InsuredTarget =>
  value === 'family' ? 'family' : 'myself';

// Present but not a known target, so a misconfigured embed can be reported.
export const isUnknownInsuredTarget = (value: unknown): boolean =>
  value != null && !(INSURED_TARGETS as readonly unknown[]).includes(value);

// Both compared to `true`, so an unresolved Statsig gate reads as off.
export const getCanOfferInsuredTarget = (
  isVhis: boolean,
  isAuthenticated?: boolean,
  isGateEnabled?: boolean,
): boolean => isVhis && isAuthenticated === true && isGateEnabled === true;

// Undefined hides the toggle.
export const getInsuredTarget = (
  canOffer: boolean,
  referralCode: string | undefined,
  selected: InsuredTarget,
): InsuredTarget | undefined =>
  canOffer && referralCode ? selected : undefined;

export const getInsuredTargetCouponCode = (
  insuredTarget: InsuredTarget | undefined,
  referralCode: string | undefined,
  fallbackCouponCode: string,
): string =>
  insuredTarget === 'family' && referralCode
    ? referralCode.toUpperCase()
    : fallbackCouponCode;
